"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThresholdContainer = exports.MobileContainer = exports.MobileButtons = exports.LoaderOverlay = exports.IndoorOverlayInfo = exports.IndoorOvelay = exports.DesktopContainer = exports.ContainerStyle = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors = __importStar(require("../../../assets/styles/colors"));
const media_1 = require("../../../utils/media");
const ContainerStyle = {
    width: "100%",
    height: "100%",
    overflow: "hidden",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
};
exports.ContainerStyle = ContainerStyle;
const DesktopContainer = styled_components_1.default.div `
  display: none;

  @media (${media_1.media.desktop}) {
    display: flex;
  }
`;
exports.DesktopContainer = DesktopContainer;
const MobileContainer = styled_components_1.default.div `
  @media (${media_1.media.desktop}) {
    display: none;
  }
`;
exports.MobileContainer = MobileContainer;
const MobileButtons = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  justify-items: center;
  align-items: center;
  gap: 0.4rem;
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 1rem 0.4rem;
  direction: rtl;
  z-index: ${(props) => (props.$isTimelapseView ? 3 : 2)};
`;
exports.MobileButtons = MobileButtons;
const ThresholdContainer = styled_components_1.default.div `
  display: grid;
  justify-content: center;
  flex-direction: column;
  position: fixed;

  grid-gap: 5rem;
  width: 100%;
  bottom: 0;
  z-index: 4;

  background-color: ${colors.white};
  box-shadow: 2px 2px 4px 0px ${colors.gray900};
  z-index: 4;

  @media (${media_1.media.mobile}) {
    height: 4.7rem;
    margin-bottom: 0;
    grid-template-columns: 1fr;
    z-index: 4;
  }

  @media (min-width: 769px) and (max-width: 1023px) {
    padding: 0.6rem 0.5rem 0.6rem 0;
    height: 4.7rem;
    grid-template-columns: 1fr auto;
    margin-bottom: 0;
    align-items: center;
    grid-gap: 0.5rem;
    z-index: 4;
  }

  @media (${media_1.media.desktop}) {
    padding: 1.6rem 4.1rem;
    height: 6.4rem;
    grid-template-columns: 1fr auto;
    margin-bottom: 0;
  }

  @media (${media_1.media.largeDesktop}) {
    padding: 1.6rem 4.1rem;
    height: 6.4rem;
    grid-template-columns: 1fr auto;
    margin-bottom: 0;
  }
`;
exports.ThresholdContainer = ThresholdContainer;
const LoaderOverlay = styled_components_1.default.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 5;
`;
exports.LoaderOverlay = LoaderOverlay;
const IndoorOvelay = (0, styled_components_1.default)(LoaderOverlay) `
  z-index: 1;
`;
exports.IndoorOvelay = IndoorOvelay;
const IndoorOverlayInfo = styled_components_1.default.div `
  position: fixed;
  top: 50%;
  left: ${(props) => (props.$isMobile ? 0 : "30%")};
  right: ${(props) => (props.$isMobile ? 0 : "30%")};
  padding: 0 1rem;
  transform: "translate(-50%, -50%)";
  text-align: center;
`;
exports.IndoorOverlayInfo = IndoorOverlayInfo;
